import './styles/globals.css';
import './styles/agent-widget-preview.css';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { applyBrandingCss } from './utils/controllers/applyBrandingCss';
import { DEFAULT_BRANDING } from './redux/slices/branding/brandingSlice';

// dayjs plugins used by the date pickers and date formatting across the app
const extendDayjsForPicker = d => {
  d.extend(customParseFormat);
  d.extend(advancedFormat);
  d.extend(weekday);
  d.extend(localeData);
  d.extend(weekOfYear);
  d.extend(weekYear);
};

extendDayjsForPicker(dayjs);

// Create a root for concurrent mode rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
const cachedBranding = localStorage.getItem('branding_cache');
let initialPrimaryColor = DEFAULT_BRANDING.primaryColor;

if (cachedBranding) {
  try {
    const branding = JSON.parse(cachedBranding);

    if (branding?.primaryColor) {
      initialPrimaryColor = branding.primaryColor;
    }
  } catch {}
}

applyBrandingCss(initialPrimaryColor);
// Render the main application inside a provider
root.render(
  <React.StrictMode>
    {/* Wrap your application with GoogleOAuthProvider */}
    <GoogleOAuthProvider clientId="80245669623-5dr2q6m64lrgpb7neq1qamjk1tf7446g.apps.googleusercontent.com">
      {/* Use the Provider component to provide the Redux store to your application */}
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
